import React, { useState } from "react";
import { useSelector } from "react-redux";

import TableHead from "../../UI/TableUI/TableHead";
import { allExpenseHeadList } from "../../../utils/TableHeadList";
import { formatDate } from "../../../functions/dateTime/formatDate";
import NoDataDisplay from "../../UI/NoDataDisplay";
import sortDataByDate from "../../../functions/sorting/sortDataByDate";
import { getExpenseStatus } from "../../../functions/getExpenseStatus";
import MobileActionHeader from "../../UI/headingsUI/MobileActionHeader";
import { filterCategoryExpense } from "../../../utils/filterCategoryList";
import { expenseSearch } from "../../../utils/tableSearchList";
import { setTableHeight } from "../../../functions/setTableHeight";
import FilterSearch from "../../common/FilterSearch";
import ExpenseViewDialog from "../../UI/viewDialogs/expense/ExpenseViewDialog";
import ImageSlider from "../../UI/viewDialogs/ImageSlider";
import { truncateDesc } from "../../../functions/truncateDesc";

const CheckExpenseHistory = () => {
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();

  const isSorted = useSelector((state) => state.data.isSorted);
  const expenseData = useSelector((state) => state.data.data);
  const copyData = useSelector((state) => state.data.copyData);
  const isCopyData = copyData.length > 0;

  let dataList = isSorted ? expenseData : sortDataByDate(expenseData, "date");
  const isDataAvailable = expenseData?.length > 0;

  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    setImageSliderPics([]);
    setViewDialogDetails({ ...viewDialogDetails, open: true });
  };
  return (
    <>
      <MobileActionHeader title="Check History" />
      {isCopyData ? (
        <FilterSearch
          categories={filterCategoryExpense}
          searchCategories={expenseSearch}
        />
      ) : (
        ""
      )}
      <div className={`table-container ${setTableHeight(isDataAvailable)}`}>
        <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
          <tbody>
            <TableHead headList={allExpenseHeadList} />
            {isDataAvailable ? (
              <>
                {dataList.map((data, index) => {
                  return (
                    <tr className="table-row" key={index}>
                      <td className="p-3">{index + 1}</td>
                      <td className="p-3">
                        {data.user.fullName} (U) <br></br>
                        {data.receiver && <>{data.receiver.fullName} (R)</>}
                      </td>
                      <td className="p-3">{`₹${data.amount}`}</td>
                      <td className="p-3">
                        {truncateDesc(data.description)}
                      </td>
                      <td className="p-3">
                        {formatDate(data.date)}
                        {data.backDated && (
                          <span className="backDatedBtn">BD</span>
                        )}
                      </td>
                      <td className="p-3">{data.category.name}</td>
                      <td
                        className={`status-data ${
                          getExpenseStatus(data.state).textColor
                        }`}
                      >
                        {getExpenseStatus(data.state).status}
                      </td>
                      <td className="p-3">
                        <button
                          className="tableViewBtn"
                          onClick={() =>
                            setViewDialogDetails({ open: true, data: data })
                          }
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <NoDataDisplay />
            )}
          </tbody>
        </table>
      </div>
      {viewDialogDetails?.open && (
        <ExpenseViewDialog
          closeDialog={closeViewDialog}
          viewDetails={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          setExpenseViewDetails={setViewDialogDetails}
        />
      )}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Expense Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};

export default CheckExpenseHistory;
